<template>
  <Field
    v-for="(field, key) in fields"
    v-model="modelValue[field.model || key]"
    v-bind="field"
    :name="field.name || key"
    :key="key"
    :error="errors[field.model || key]"
  />
</template>

<script>
import Field from 'Web/Form/Field.vue';

export default {
  inheritAttrs: false,
  components: {
    Field,
  },
  props: {
    errors: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Object,
      default: () => ({}),
    },
    modelValue: Object,
  }
}
</script>
